import React, { useEffect, useState } from "react";

import UserPanelHeader from "./../components/UserPanelHeader";
import UserPanelSearchModal from "../components/UserPanelSearchModal";
import Sidebar from "../components/Sidebar/Sidebar";

const cssFiles = [
  "/assets/UserPanelAssets/css/bootstrap.min.css",
  "/assets/UserPanelAssets/css/bootstrap-datetimepicker.min.css",
  "/assets/UserPanelAssets/plugins/daterangepicker/daterangepicker.css",
  "/assets/UserPanelAssets/plugins/fontawesome/css/fontawesome.min.css",
  "/assets/UserPanelAssets/plugins/fontawesome/css/all.min.css",
  "/assets/UserPanelAssets/plugins/tabler-icons/tabler-icons.min.css",
  "/assets/UserPanelAssets/plugins/simplebar/simplebar.min.css",
  "/assets/UserPanelAssets/css/style.css",
  "/assets/UserPanelAssets/css/customUserPanel.css",
];

export default function UserPanelLayout({ children, production }) {
  const [cssLoaded, setCssLoaded] = useState(false);

  useEffect(() => {
    let loadedCount = 0;
    const links = cssFiles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.dataset.theme = "ayurveda";

      // Increment counter when each CSS finishes loading
      link.onload = () => {
        loadedCount++;
        if (loadedCount === cssFiles.length) {
          setCssLoaded(true);
        }
      };

      document.head.appendChild(link);
      return link;
    });

    // Cleanup on unmount
    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  // Don't render children until CSS is fully loaded
  if (!cssLoaded) {
    return <div style={{ visibility: "hidden" }}>Loading...</div>;
  }

  return (
    <div class="main-wrapper">
      <UserPanelHeader />
      <UserPanelSearchModal />
      <Sidebar />
      <main>{children}</main>
    </div>
  );
}
